<template>
  <div class="container--login">
    <div id="login">
      <img src="/img/04_Subit_logo_B.png" alt="logo_menu" class="logo" style="width: 280px" />
      <div id="login_box">
        <form action="" method="post" class="login_form" onsubmit="return false;" @submit.prevent="submit">
          <dl>
            <div class="lf_email">
              <dt><label for="email">Email</label></dt>
              <dd>
                <input type="text" name="email" v-model="form.email" placeholder="Email" id="email" />
              </dd>
            </div>
            <div class="lf_pass">
              <dt><label for="password">Password</label></dt>
              <dd>
                <input type="password" name="password" v-model="form.password" placeholder="Password" id="password" />
              </dd>
            </div>
            <div class="lf_submit">
              <input type="submit" value="Login" id="sb" class="btn-purple btn" />
            </div>
          </dl>
        </form>
      </div>
    </div>
  </div>
</template>

<style lang="css">
* {
  padding: 0;
  margin: 0;
}
.close_btn {
  float: right;
  margin: 10px;
  width: 70px;
}
.error_box {
  position: fixed;
  z-index: 10;
  width: 100%;
  height: 100%;
  background: rgba(1, 1, 1, 0.3);
}
.eb {
  border: solid black;
  background: #fffbf9;
  width: 350px;
  height: 160px;
  position: absolute;
  top: 5%;
  left: 50%;
  transform: translate(-50%);
}
.eb p {
  margin: 0;
  padding: 10px;
  font-size: small;
  font-weight: 300;
}
.error {
  background: #d20000;
  color: white;
}
.fp {
  text-align: center;
}
.fp a {
  opacity: 0.5;
  color: black;
}
input::placeholder {
  text-align: center;
}
#email,
#password {
  width: 280px;
}
#sb {
  width: 280px;
  margin: 15px 0;
  background: #183e7a;
  border-radius: 30px;
  color: white;
  font-weight: bold;
}
.active {
  display: block;
}
.lf_rm {
  position: relative;
}
.lf_submit {
  float: right;
}
.logo {
  display: block;
  margin: 0 auto;
}
.body {
  width: 100%;
  height: 100%;
  position: relative;
}
#login {
  position: absolute;
  top: 50%;
  left: 25%;
  color: white;
  transform: translate(-50%, -50%);
}
#login_box {
  padding: 12px 10px 10px 10px;
  width: 300px;
  height: 200px;
}
</style>

<script>
import Email from '@/Pages/Components/validateEmail.js';
import Password from '@/Pages/Components/validatePassword.js';

export default {
  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
      }),
      isActive: false,
      width: window.innerWidth,
      height: window.innerHeight,
    };
  },
  methods: {
    submit() {
      try {
        Email.isInvalid(this.form.email);
        Password.isInvalid(this.form.password);

        this.form
          .post(this.route('admin.store'), {
            onError: (e) => {
              alert(e.message);
            },
          });
      } catch (error) {
        alert(error.message);
      }
    },
    handleResize: function () {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      return {
        '--height': this.height,
      };
    },
  },
  mounted: function () {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>
